<template>
  <v-container fluid class="ma-0 pa-0">
    <AdminBreadCrumb title="テーマ管理" />
    <EditTheme
      :systemOwnerLoading="isSystemOwnerLoading"
      :systemOwner="systemOwner"
      :themeList="themeList"
      :form="formData"
      :loading="loading"
      @setBrandTitle="setBrandTitle"
      @setColorThemeId="setColorThemeId"
      @save="save"
    />
  </v-container>
</template>

<script>
import AdminBreadCrumb from '../../components/Shared/BreadCrumb/AdminBreadCrumb.vue'
import { actions, snackbarType } from '@/vuex/modules/ui/snackbar/constants'
import { getSystemOwner } from '@/mixins/getSystemOwner'
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdmin } from '@/mixins/setDrawerTypeAdmin'
import { setToolBarTypeAdmin } from '@/mixins/setToolBarTypeAdmin'
import EditTheme from '@/components/Admin/Theme/EditTheme'
import { actions as colorThemeActions } from '@/vuex/modules/ui/colorTheme/constants'

class EditThemeForm {
  constructor(item) {
    const { brandTitle, theme } = item
    this.brandTitle = brandTitle || undefined
    this.colorThemeId = theme || undefined
  }
}

export default {
  name: 'Theme',
  components: { EditTheme, AdminBreadCrumb },
  mixins: [
    accountInitializer,
    setDrawerTypeAdmin,
    setToolBarTypeAdmin,
    getSystemOwner,
  ],
  data: () => ({
    loading: false,
    displayConfirmModal: false,
    formData: undefined,
  }),
  computed: {
    systemOwner() {
      return this.$store.getters['account/systemOwner']
    },
    currentTheme() {
      if (this.systemOwner == null) return null
      return this.systemOwner.theme
    },
    themeList() {
      return this.$store.getters['colorTheme/themeList']
    },
    isSystemOwnerLoading() {
      return Boolean(!Object.keys(this.systemOwner).length)
    },
  },
  watch: {
    currentTheme(newVal) {
      // テーマのget処理がcreatedより後だったときに動く
      this.setBrandTitle(newVal.brandTitle)
      this.setColorThemeId(newVal.id)
    },
  },
  async created() {
    this.formData = new EditThemeForm({})
    this.initThemeList()
    if (this.currentTheme != null) {
      this.setBrandTitle(this.currentTheme.brandTitle)
      this.setColorThemeId(this.currentTheme.id)
    }
  },
  methods: {
    initTheme(theme) {
      this.setColorThemeId(theme.id)
      this.setBrandTitle(theme.brandTitle)
    },
    setColorThemeId(id) {
      this.formData.colorThemeId = id
    },
    setBrandTitle(brandTitle) {
      this.formData.brandTitle = brandTitle
    },
    async initThemeList() {
      await this.$store.dispatch('colorTheme/GET_ALL_THEME')
    },
    async save() {
      this.loading = true
      try {
        await this.$store.dispatch('colorTheme/SAVE', {
          form: this.formData,
          systemOwnerId: this.systemOwner.id,
        })
        await this.$store.dispatch(actions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message: '保存完了しました',
        })
        // カラーテーマ再取得
        await this.$store.dispatch(colorThemeActions.INITIALIZE)
        // Vuetifyデフォルトテーマへの反映
        this.applyThemeColor()
      } catch (e) {
        const error = new Error('保存に失敗しました')
        this.loading = false
        throw error
      }
      this.loading = false
    },
    applyThemeColor() {
      this.$vuetify.theme = {
        ...this.$vuetify.theme,
        ...this.themeColor,
      }
    },
  },
}
</script>

<style scoped></style>
